import React from 'react'

import ControlFoldable from '../../../gd-app/component/control-blocks/foldable'
import FormManager from "../../../gd-form/common/form-manager"

type Props = {
    className?              : string

    title                   : string
    typeFilterValues        : any[]
    lockedValues?           : any[]

    type                    : 'default' | 'new' | 'form'

    // Form
    form?                   : FormManager
    name?                   : string

    // NOT Form
    filterTypes             : any[]                       // if not form passed will be component with selected value
    onSelect                : {(types: ID[]):void}

    disabled                : boolean
    isFoldable              : boolean
    isAnimated              : boolean
    obligatoryItemsNum      : number
    localSettings?          : any
    foldStateSettingsName?  : string
}

type State = {
    isOpen      : boolean
    filterTypes : any[]
}

export default class MultiselectOptions extends React.Component<Props, State> {

    static defaultProps = {
        title               : "Options",
        type                : 'default',
        disabled            : false,
        isFoldable          : true,
        isAnimated          : false,
        obligatoryItemsNum  : 1
    }

    constructor(props: Props) {
        super(props)

        this.state = this._getState(props)

        if (this.props.form && this.props.name) {
            this.props.form.registerFormComponent(this.props.name,this)
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        this.setState(this._getState(nextProps));
    }

    _addLockedValues = (values: any[]) => {
        let res: any[] = values?.slice() || []
        if (this.props.lockedValues) {
            res =  res.concat(this.props.lockedValues)
        }
        return _.uniq(res)
    }

    _getState(props: Props) {
        let filterTypes;
        if (this.props.form && this.props.name) {
            filterTypes = this.props.form.getValue(this.props.name);
            if (!filterTypes) filterTypes = [];
        } else {
            filterTypes = props.filterTypes
        }

        const isOpen = !props.disabled && props.localSettings && props.foldStateSettingsName ?
            (!_.isNil(props.localSettings[props.foldStateSettingsName]) ? props.localSettings[props.foldStateSettingsName] : props.localSettings.get(props.foldStateSettingsName) === '1')
            :
            !props.isFoldable;

        return {
            isOpen: isOpen,
            filterTypes: this._addLockedValues(filterTypes)
        };
    }

    clear = () => {
        this.onClearClick();
    };

    onFoldBtnClick = () => {
        if (this.props.disabled) return;

        const value = !this.state.isOpen;
        const { localSettings, foldStateSettingsName } = this.props;
        if (localSettings && foldStateSettingsName) {
            if (typeof localSettings.saveParam === 'function') localSettings.saveParam(foldStateSettingsName, value);
            else if (typeof localSettings.set === 'function') localSettings.set(foldStateSettingsName,value ? '1' : '0');
            else localSettings[foldStateSettingsName] = value;
        }

        this.setState({
            isOpen: value
        });
    };

    onClearClick = () => {
        const { typeFilterValues, onSelect } = this.props;

        const newTypes = typeFilterValues.map(f=>f.value);
        if (this.props.form && this.props.name) {
            this.props.form.onFormComponentValueChange(this.props.name,newTypes);
        }

        this.setState({
            filterTypes: this._addLockedValues(newTypes)
        }, ()=>{
            if (onSelect) onSelect(newTypes);
        });
    };

    onItemClick = (value: any) => {
        if (this.props.lockedValues &&
            this.props.lockedValues.includes(value) &&
            this.state.filterTypes.includes(value)) return; //this value is not allowed to remove

        const newTypes = gd.utils.toggleArrayValue(this.state.filterTypes, value);

        if (newTypes.length >= this.props.obligatoryItemsNum) {
            if (this.props.form && this.props.name) {
                this.props.form.onFormComponentValueChange(this.props.name,newTypes);
            }

            this.setState({
                filterTypes: this._addLockedValues(newTypes)
            }, ()=>{
                if (this.props.onSelect) this.props.onSelect(newTypes);
            });
        }
    };

    render() {
        let value: any;
        if (this.props.form && this.props.name)   {
            value = this.props.form.getValue(this.props.name)   // Form mode
        } else {
            value = this.state.filterTypes                      // no form stand alone mode
        }

        const availableIds = this.props.typeFilterValues.map(tfv => tfv.value);
        const selectedButNotAvailable = _.difference(value, availableIds).length;
        const availableButNotSelected = _.difference(availableIds, value).length;

        const showClearButton = !this.state.isOpen && availableButNotSelected > 0;
        const counter = showClearButton ? value.length - selectedButNotAvailable : null;

        return (
            <ControlFoldable className={Classes("multiselect-options", this.props.type+"-filter-type", this.props.className)}
                             title={this.props.title}
                             isOpen={!!this.state.isOpen}
                             isFoldable={this.props.isFoldable}
                             onOpenClosed={this.onFoldBtnClick}
                             onClear={this.onClearClick}
                             counter={counter}
                             showClearButton={showClearButton}
                             delimiter={false}
                             disabled={this.props.disabled}
                             isAnimated={this.props.isAnimated}>
                {this.props.typeFilterValues.map(v=>{
                    const isSelected = value.includes(v.value);
                    const isDisabled = v.disabled || (this.props.lockedValues && this.props.lockedValues.includes(v.value))
                    const itemClasses = Classes("type-option", {
                        'selected': isSelected,
                        'disabled': isDisabled
                    });

                    const checkBoxClasses = Classes('check-box', 'gd-cb-12', {
                        selected: isSelected
                    });

                    return (
                        <div key={v.value} className={itemClasses} onClick={!v.disabled ? this.onItemClick.bind(this,v.value) : undefined}>
                            <div className={checkBoxClasses}/>
                            {v.icon && <div className={Classes("option-icon", v.icon)}> </div>}
                            {v.label}
                            <div className="cf"/>
                        </div>
                    );
                })}
            </ControlFoldable>
        );
    }
}